import { Injectable } from '@angular/core';
import { ShopApiService } from '@digilize/shared/data/services/src';
import { Company, DataApiResponseLegacy, Shop } from '@digilize/shared/definitions/src';
import { BehaviorSubject, filter, switchMap } from 'rxjs';

import { ActiveCompanyService } from './active-company.service';

@Injectable({
  providedIn: 'root',
})
export class ShopService {
  activeShop: BehaviorSubject<Shop> = new BehaviorSubject<Shop>(null);
  private _companyShops = new BehaviorSubject<Shop[]>(null);
  companyShops$ = this._companyShops.asObservable();
  get companyShops() {
    return this._companyShops.value;
  }
  set companyShops(companyShops: Shop[]) {
    this._companyShops.next(companyShops);
  }

  state;
  editedMovie;

  constructor(private activeCompanyService: ActiveCompanyService, private shopApiService: ShopApiService) {}

  init() {
    this.activeCompanyService.activeCompany$
      .pipe(
        filter((company) => !!company?.id),
        switchMap((company: Company) => {
          return this.shopApiService.getShops({ company: company.id });
        })
      )
      .subscribe((res: DataApiResponseLegacy<Shop[]>) => {
        if (res.data?.length) {
          this.companyShops = res.data;
          const lastSelectedShopId = localStorage.getItem('lastSelectedShopId');
          const lastSelectedShop = this.companyShops.find((shop) => shop.id === lastSelectedShopId);
          const defaultShop = lastSelectedShop || this.companyShops[0];
          this.activeShop.next(defaultShop);
        }
      });
  }

  setActiveShop(shop: Shop) {
    this.activeShop.next(shop);
  }

  getActiveShop() {
    return this.activeShop.asObservable();
  }

  setEditedMovie(movie) {
    this.editedMovie = movie;
  }
}
